import React from "react";
import RoutesConfig from "./routes/RoutesConfig";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import { useLocation, matchPath } from "react-router-dom";

const App = () => {
  const location = useLocation();
  const excludedRoutes = [
    "/admin", "/design", "/admin/dashboard", "/admin/sub-category-pricing", "/admin/field-pricing", "/admin/users_data", "/admin/admin_data", "/admin/transaction", "/admin/subscribers", "/admin/current_orders", "/admin/dispatched_orders", "/admin/productdescription", "/template", "/admin/headerdescription", "/admin/upload_designassets", "/admin/category_image_upload", "/admin/category_images_delete_update", "/admin/send_client_mail", "/admin/category_keywords", "/admin/field_description", '/admin/view_referral_users', '/admin/view_all_referral_agents', '/admin/create_referral_agent', '/admin/you_may_like', '/admin/offline_order_images', '/admin/offline_orders', "/billing-page/*",
    
    "/admin/", "/design/", "/admin/dashboard/", "/admin/sub-category-pricing/", "/admin/field-pricing/", "/admin/users_data/", "/admin/admin_data/", "/admin/transaction/", "/admin/subscribers/", "/admin/current_orders/", "/admin/dispatched_orders", "/admin/productdescription/", "/template/", "/admin/headerdescription/", "/admin/upload_designassets", "/admin/category_image_upload", "/admin/category_images_delete_update", "/admin/send_client_mail", "/admin/category_keywords", "/admin/field_description", '/admin/view_referral_users', '/admin/view_all_referral_agents', '/admin/create_referral_agent', '/admin/you_may_like', '/admin/offline_order_images', '/admin/offline_orders', "/billing-page/*",];
    
  // const shouldHideHeaderFooter = excludedRoutes.includes(location.pathname);
  
  const shouldHideHeaderFooter = excludedRoutes.some(route =>
    matchPath({ path: route, end: false }, location.pathname)
  );

  return (
    <div>
      {!shouldHideHeaderFooter && <Header />}
      <RoutesConfig />
      {!shouldHideHeaderFooter && <Footer />}
    </div>
  );
};

export default App;